export default __webpack_public_path__ + "static/media/gallery_07.ab536d03.jpg";